// Progress Row Types:
export const PROGRESS_ROW_TYPE_ACTIVITY = 'Activity';
export const PROGRESS_ROW_TYPE_MATERIAL_SPEND = 'Material Spend';
export const PROGRESS_ROW_TYPE_SPEND = 'Spend'
export const PROGRESS_ROW_TYPE_HOURS = 'Hours';
export const PROGRESS_ROW_TYPE_LABOR_COST = 'Labor Cost';

